export default "__VITE_ASSET__FEf7PlNM__"